import React, { useEffect } from 'react'
import Layout from '../components/Layout/Layout'
import Seo from '../components/seo'
import AboutUs from '../components/AboutUs/AboutUs'
import Requeriments from '../components/Requeriments/Requeriments'
import KnowOurCredit from '../components/KnowOurCredit/KnowOurCredit'
import GetYourCredit from '../components/GetYourCredit/GetYourCredit'
import WhySection from '../components/WhySection/WhySection'
import WrittenAboutUs from '../components/WrittenAboutUs/WrittenAboutUs'
import Questions from '../components/Questions/Questions'
import * as ROUTES from '../utils/constants'
import CurveGeneral from '../components/CurveGeneral/CurveGeneral'

export default function IndexPage () {
  useEffect(() => {
    if (window) {
      const checks = window.document.querySelectorAll('.Check__label_wrapper')
      const inputs = window.document.querySelectorAll('.css-hrhtmw-InputTextComponent')

      for (let i = 0; i < checks.length; i++) {
        checks[i].className = 'customCheck'
      }

      for (let j = 0; j < inputs.length; j++) {
        inputs[j].style.fontFamily = 'GrottaRegular'
      }
    }
  }, [])

  return (
    <Layout route={ROUTES.PREFIX}>
      <Seo
        title='Liquidez'
        url={`${ROUTES.MAIN_LINK}${ROUTES.PREFIX}`}
      />
      <AboutUs />
      <KnowOurCredit />
      <Requeriments />
      <GetYourCredit />
      <CurveGeneral />
      <WhySection />
      <WrittenAboutUs />
      <Questions />
    </Layout>
  )
}
